module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-usage"
  }, [_c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === ''
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = ''
      }
    }
  }, [_vm._v("\n            Alle medarbejdere\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, funktionær'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, funktionær'
      }
    }
  }, [_vm._v("\n            Svende, funktionær\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, timelønnet'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, timelønnet'
      }
    }
  }, [_vm._v("\n            Svende, timelønnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Lærling'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Lærling'
      }
    }
  }, [_vm._v("\n            Lærlinge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsage"
    }
  }), _vm._v("\n                    Opsummering\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('pie', {
    attrs: {
      "headline": "Tid brugt hos kunderne",
      "series": _vm.hoursDivision.series,
      "labels": _vm.hoursDivision.labels,
      "division": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('pie', {
    attrs: {
      "headline": "Fordeling af tid hos kunderne",
      "series": _vm.hoursWithCustomers.series,
      "labels": _vm.hoursWithCustomers.labels,
      "division": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('pie', {
    attrs: {
      "headline": "Fordeling af anden tid",
      "series": _vm.hoursWithoutCustomers.series,
      "labels": _vm.hoursWithoutCustomers.labels,
      "division": false
    }
  })], 1)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])]), _vm._v(" "), _c('employee-time-usage', {
    attrs: {
      "employeeWorkingFieldName": _vm.employeeWorkingFieldName
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06c72782", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c72782"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/timeUsage.vue
// module id = 778
// module chunks = 0